// LPの機能一覧(/product)の絞り込み(lp-catalog-filter)で使う純関数

// 全角英数・半角カナの揺れと大文字小文字を吸収して比べられる形にする
export function normalizeText(value) {
  return String(value ?? "").normalize("NFKC").toLowerCase().replace(/\s+/g, " ").trim()
}

// SNSの別名(カタカナの呼び方・旧名)。カードに対応SNSとして付いているSNSは、別名のキーワードでも見つかるようにする
export const SNS_ALIASES = {
  instagram: ["Instagram", "インスタ", "インスタグラム"],
  x: ["X", "Twitter", "ツイッター", "エックス"],
  tiktok: ["TikTok", "ティックトック"],
  youtube: ["YouTube", "ユーチューブ"],
  facebook: ["Facebook", "フェイスブック"],
  threads: ["Threads", "スレッズ"],
}

export function snsAliasText(snsList) {
  return (snsList || []).flatMap((sns) => SNS_ALIASES[sns] || []).join(" ")
}

// data-purposes="measurement report" のような空白区切りの値を配列にする
export function splitList(value) {
  return String(value ?? "").split(/\s+/).filter(Boolean)
}

// item: { purposes: [...], sns: [...], text: "カードの文言" }
// filter: { purpose: "", sns: "", query: "" }(空文字はその条件で絞り込まない)
// キーワードは空白で区切った語をすべて含むときに一致とする(部分一致)
export function matchesFilter(item, { purpose = "", sns = "", query = "" } = {}) {
  if (purpose && !(item.purposes || []).includes(purpose)) return false
  if (sns && !(item.sns || []).includes(sns)) return false

  const text = normalizeText(item.text)
  return normalizeText(query).split(" ").filter(Boolean).every((token) => text.includes(token))
}
